


























import Vue from "vue";
import Prism from "prismjs";

export default Vue.extend({
    methods: {
        highlight(code: string): string {
            return Prism.highlight(code, Prism.languages.javascript, "javascript");
        }
    }
});
